import { render } from "./paginacaoLista.vue?vue&type=template&id=d1998122&scoped=true&ts=true"
import script from "./paginacaoLista.vue?vue&type=script&lang=ts"
export * from "./paginacaoLista.vue?vue&type=script&lang=ts"

import "./paginacaoLista.vue?vue&type=style&index=0&id=d1998122&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d1998122"],['__file',"src/components/PaginacaoLista/paginacaoLista.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d1998122"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d1998122', __exports__)) {
    api.reload('d1998122', __exports__)
  }
  
  module.hot.accept("./paginacaoLista.vue?vue&type=template&id=d1998122&scoped=true&ts=true", () => {
    api.rerender('d1998122', render)
  })

}


export default __exports__